import React from 'react';
import { TableBody as MuiTableBody, TableCell, TableRow } from '@material-ui/core';
import { useStyles } from './styles';
import { IOrderHistory } from 'pages/orderHistoryDetails/hooks/useOrderHistory';

interface ITableBodyProps {
  order: IOrderHistory[];
}

export const TableBody = ({ order }: ITableBodyProps) => {
  const styles = useStyles();

  return (
    <MuiTableBody>
      {order.map((order, i) => (
        <TableRow key={i}>
          {Object.entries(order).map(([key, value]) =>
            key === '__typename' || key === 'totalRows' ? null : (
              <TableCell key={key} className={styles.tableRowCell} component="th" scope="row">
                {value}
              </TableCell>
            )
          )}
        </TableRow>
      ))}
    </MuiTableBody>
  );
};
